import { render, staticRenderFns } from "./BeneficiaryHomeData.vue?vue&type=template&id=24502b32&"
import script from "./BeneficiaryHomeData.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryHomeData.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryHomeData.vue?vue&type=style&index=0&id=24502b32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports